/** @deprecated */
export let AccordionVariant = /*#__PURE__*/function (AccordionVariant) {
  AccordionVariant["Inline"] = "inline";
  AccordionVariant["FullPage"] = "full-page";
  return AccordionVariant;
}({});
export const LEADING_TRAILING_ALIGNMENTS = ['center', 'top'];